package com.example.mystybag.appCore.logic

import com.example.mystybag.core.logic.base.NavigatorConfig
import com.example.mystybag.core.logic.base.ParentCallback
import com.example.mystybag.core.logic.base.UIBottomSheetConfig
import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel

/** Callback for Bag page: allows notifying parent after successful reservation (e.g. navigate to Delivery). */
interface BagPageCallback : ParentCallback {
    fun onReservationSuccess(reservationId: Long)

    /**
     * Web-only: server polling confirmed payment while checkout UI is still open (iframe cannot expose
     * success URL cross-origin). Invoked only from [com.example.mystybag.appCore.logic.pages.BagViewModel]
     * when [com.example.mystybag.core.expected.PlatformHelper.isWeb] is true. Android/iOS use WebView URL /
     * console signals instead; default is no-op.
     */
    fun onEmbeddedCheckoutServerConfirmedPaid() {}
}

object NavigatorMain: NavigatorConfig()

data class NavigatorSettingsAndNotifications(val isForNotifications: Boolean = false): NavigatorConfig()

object NavigatorNotifications: NavigatorConfig()

/** Notification settings screen – opened from Profile (Известия). */
object NavigatorNotificationSettings: NavigatorConfig()

/** Settings screen – opened from Profile (Настройки). */
object NavigatorSettings: NavigatorConfig()

/** Stored cards screen – opened from Profile (Методи на плащане). */
object NavigatorStoredCards: NavigatorConfig()

object NavigatorPersonalDetails: NavigatorConfig()

/** Delete account request screen – user submits a message; team reviews and responds. */
object NavigatorDeleteAccountRequest: NavigatorConfig()

object NavigatorMystyBagActivity : NavigatorConfig()

/** BOTTOM SHEET CONFIG */

class BSNavigatorOnlineSession(val onStopSessionButtonClicked: () -> Unit ): UIBottomSheetConfig()

data class BSNavigatorReservationDetails(
    val reservation: com.example.mystybag.sharedmodels.project.database.UserReservationModel
): UIBottomSheetConfig()

/** Full-screen Leave Review – when user has not given review yet (isReviewGiven = false). */
data class NavigatorLeaveReview(
    val reservation: com.example.mystybag.sharedmodels.project.database.UserReservationModel
): NavigatorConfig()

/** BOTTOM SHEET CHILD */

//class OnlineSessionBottomSheetChild(override val viewModel: OnlineSessionBottomSheetViewModel): BottomSheetChild(viewModel = viewModel)

class ReservationDetailsBottomSheetChild(
    override val viewModel: com.example.mystybag.appCore.logic.pages.ReservationDetailsBottomSheetViewModel
) : com.example.mystybag.core.logic.base.BottomSheetChild(
    viewModel = viewModel,
    showNotch = false,
    removeBottomSheetPadding = true,
    useWebDialogInsets = true
)

class FilterResultsBottomSheetChild(override val viewModel: com.example.mystybag.appCore.logic.pages.FilterResultsBottomSheetViewModel) : com.example.mystybag.core.logic.base.BottomSheetChild(
    viewModel = viewModel,
    removeBottomSheetPadding = true,
    useWebDialogInsets = true
)

/** PAGES NAVIGATION */

/** Used with MainCallback.popToMainAndNavigate to switch main tab without pushing a new screen (e.g. from empty reservations to Find). */
data class NavigatorSelectPage(val pageIndex: Int) : NavigatorConfig()

object NavigatorPageHome      : NavigatorConfig()
object NavigatorPageDelivery : NavigatorConfig()
object NavigatorPageFavorites: NavigatorConfig()
object NavigatorPageProfile  : NavigatorConfig()

/** MERCHANT PAGES NAVIGATION */

object NavigatorPageDashboard : NavigatorConfig()
object NavigatorPageBags      : NavigatorConfig()
/** Tab "Обекти" – shows MerchantLocationsList (Търговски обекти) screen. */
object NavigatorPageLocations : NavigatorConfig()
object NavigatorPageMenu     : NavigatorConfig()

/** BAG DETAIL PAGE */

data class NavigatorBagPage(val bagItem: HomeTopPickUiModel?) : NavigatorConfig()

/** ADD BAG PAGE (bagId != null = edit mode) */

data class NavigatorAddBag(
    val merchantLocationId: Long,
    val businessCategoryId: Long? = null,
    val bagId: Long? = null
) : NavigatorConfig()

/** MERCHANT LOCATIONS */

object NavigatorMerchantLocationsList : NavigatorConfig()

data class NavigatorMerchantLocationDetails(
    val locationId: Long
) : NavigatorConfig()

/** MERCHANT PROFILE */

object NavigatorMerchantProfileDetails : NavigatorConfig()

/** STAFF LIST - from Menu, merchant only */

object NavigatorStaffList : NavigatorConfig()

/** COMPANY RESPONSIBLE PERSONS LIST - from Menu (Отговорни лица на компанията) */

object NavigatorCompanyResponsiblePersonsList : NavigatorConfig()

/** CONTACTS PAGE - from Menu (Контакти) */

object NavigatorContacts : NavigatorConfig()

/** STATEMENTS (Извлечения) – PAID_TO_MERCHANT reservations */

object NavigatorStatements : NavigatorConfig()

/** EDIT COMPANY RESPONSIBLE PERSON - from list, by person id */

data class NavigatorCompanyResponsiblePersonEdit(val personId: Long) : NavigatorConfig()

/** ADD EMPLOYEE (staff) - from Staff list, merchant only */

object NavigatorAddEmployee : NavigatorConfig()

/** EDIT EMPLOYEE (staff) - from Staff list, merchant only */

data class NavigatorEditEmployee(val staffId: Long) : NavigatorConfig()

/** CATEGORY BAGS LIST */

data class NavigatorCategoryBagsList(
    val businessCategoryId: Long?,
    val categoryTitle: String,
    val bags: List<HomeTopPickUiModel>
) : NavigatorConfig()